import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

const fetchEventSpaceGraph = async (graphVar) => {
    const { plateId, wellId } = graphVar;
    const headerConfig = setHeaders();
    const { data: urlWrapper } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/graph/event_space/${plateId}/${wellId}`,
        { headers: headerConfig }
    );
    const { data: graphData } = await axios.get(urlWrapper.signedUrl);
    return graphData;
};

export default function useFetchEventSpaceGraphData(graphVar) {
    return useQuery(["eventSpaceGraph", graphVar], () => fetchEventSpaceGraph(graphVar), {
        enabled: !!(graphVar?.plateId && graphVar?.wellId),
        onError: (error) => console.log({ error }),
        refetchOnWindowFocus: false,
    });
}
